import { connect } from 'react-redux'
import { makeLogicNodeSelector } from 'selectors/feature/logicNodes'
import {
  makeLogicSetSimulationsSelector,
  getSimulationMeta,
} from 'selectors/feature/simulation'
import LogicSetSimulator from './LogicSetSimulator'

const makeMapStateToProps = () => {
  const querySelector = makeLogicNodeSelector()
  const simulationsSelector = makeLogicSetSimulationsSelector()
  const mapStateToProps = (state, ownProps) => {
    const { uri } = ownProps
    const query = querySelector(state, { queryUri: uri })
    const sims = simulationsSelector(state, { queryUri: uri })
    const { playing } = getSimulationMeta(state)
    const {
      description,
      finalComplexQueryOperator,
      abComplexQueryOperator,
      cdComplexQueryOperator,
      delayActivate,
      delayDeactivate,
      conditions,
    } = query || {}

    return {
      ...ownProps,
      finalComplexQueryOperator,
      abComplexQueryOperator,
      cdComplexQueryOperator,
      delayActivate,
      delayDeactivate,
      description,
      conditions,
      animationPlaying: playing,
      ...sims,
    }
  }
  return mapStateToProps
}

const connected = connect(makeMapStateToProps)(LogicSetSimulator)

export default connected
